"use client";
import { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import { Collapse } from "react-collapse";
import navigation from "@/data/navigation";
import { NavigationType } from "@/types/navigation";
import { social } from "@/data/data";
import Hyperlink from "@/components/ui/hyperlink";
interface MobileMenuProps {
    isOpen: boolean;
    onClose: () => void;
}

const MobileMenu = ({ isOpen, onClose }: MobileMenuProps) => {
    const [openMenus, setOpenMenus] = useState<Record<string, boolean>>({});
    const toggleMenu = (label: string) => {
        setOpenMenus((prev) => {
            const newState = Object.keys(prev).reduce(
                (acc, key) => ({
                    ...acc,
                    [key]: false,
                }),
                {}
            );

            return {
                ...newState,
                [label]: !prev[label],
            };
        });
    };

    const renderMenuItem = (item: NavigationType) => {
        const isMenuOpen = openMenus[item.label] || false;
        const hasDropdown = item.dropdown || item.isMegaDropdown;

        return (
            <li
                key={item.label}
                className={`menu-item-has-children ${isMenuOpen ? "active" : ""
                    }`}
            >
                {hasDropdown ? (
                    <>
                        <Link
                            href={item.href || "#"}
                            className="menu-link d-flex justify-content-between"
                        >
                            {item.label}
                            <i
                                onClick={() => toggleMenu(item.label)}
                                className={`ri-arrow-${isMenuOpen ? "up" : "down"
                                    }-s-line`}
                            />
                        </Link>
                        <Collapse isOpened={isMenuOpen}>
                            <ul className="sub-menu">
                                {/* Render regular dropdown items */}
                                {item.dropdown && item.dropdown.map((subItem) => (
                                    <li key={subItem.label}>
                                        <Link
                                            href={subItem.href || "#"}
                                            onClick={onClose}
                                        >
                                            {subItem.label}
                                        </Link>
                                    </li>
                                ))}

                                {/* Render mega dropdown submenu titles */}
                                {item.isMegaDropdown && item.rightPanel?.items && item.rightPanel.items.map((subItem, index) => (
                                    <li key={`${item.label}-${index}`}>
                                        <Link
                                            href={subItem.href || "#"}
                                            onClick={onClose}
                                        >
                                            {subItem.title}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </Collapse>
                    </>
                ) : (
                    <Link href={item.href || "#"} onClick={onClose}>
                        {item.label}
                    </Link>
                )}
            </li>
        );
    };

    return (
        <>
            <div
                className={`desilo-menu-wrapper ${isOpen ? "desilo-body-visible" : ""
                    }`}
            >
                <div className="desilo-menu-area text-center">
                    <div className="desilo-menu-mobile-top">
                        <div className="mobile-logo">
                            <Link href="/" onClick={onClose}>
                                <Image
                                    src="/images/logo-dark.svg"
                                    alt="logo"
                                    width={120}
                                    height={20}
                                    priority
                                />
                            </Link>
                        </div>
                        <button
                            className="desilo-menu-toggle mobile"
                            onClick={onClose}
                        >
                            <i className="ri-close-line" />
                        </button>
                    </div>
                    <div className="desilo-mobile-menu">
                        <ul>{navigation.map(renderMenuItem)}</ul>
                    </div>
                    <div className="d-flex justify-content-start border-bottom border-black d-lg-none">
                        <Hyperlink
                            className="small-btn"
                            href="/contact"
                            variant={"tertiary"}
                        >
                            Get in touch
                        </Hyperlink>
                    </div>
                    <div className="desilo-mobile-menu-btn">
                        <Link href="https://www.google.com/maps/place/Desilo+Technologies+Pvt.+Ltd./@23.0297936,72.4778082,17z/data=!4m14!1m7!3m6!1s0x395e9b64c2972d6d:0xe49c7e696133604e!2sDesilo+Technologies+Pvt.+Ltd.!8m2!3d23.0297936!4d72.4778082!16s%2Fg%2F11lryh1mxd!3m5!1s0x395e9b64c2972d6d:0xe49c7e696133604e!8m2!3d23.0297936!4d72.4778082!16s%2Fg%2F11lryh1mxd?entry=ttu&g_ep=EgoyMDI1MTAwMS4wIKXMDSoASAFQAw%3D%3D" target="_blank" className="sidebar-wrap">
                            <h6>808, Sun Central Place, Ambali,</h6>
                            <h6>Ahmedabad, India - 380058</h6>
                        </Link>
                        <div className="sidebar-wrap mb-2">
                            <h6 className="mt-2">
                                <Link href="tel:+919033939547">
                                    +91 90339 39547
                                </Link>
                            </h6>
                            <h6 className="mt-2">
                                <Link href="mailto:hello@desilo.studio">
                                    hello@desilo.studio
                                </Link>
                            </h6>
                        </div>
                        <div className="social-btn style-3">
                            {/* social media start */}
                            {social.map((item, i) => (
                                <Link key={i} href={item.href} target="_blank">
                                    <span className="link-effect">
                                        <span className="effect-1">
                                            <i className={item.iconClass} />
                                        </span>
                                        <span className="effect-1">
                                            <i className={item.iconClass} />
                                        </span>
                                    </span>
                                </Link>
                            ))}
                            {/* social media end */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MobileMenu;
